import { Component, Injector } from '@angular/core';
import { ColumnDefinition, Filter, PagedCollectionComponent, doMultiSelect, FilterProperty, FilterBuilder, doAlert, createColumnDefinitions, SearchableType, DialogsService } from '@mango/core';
import { User } from './user';
import { UserService } from './user.service';
import { MatDialog } from '@angular/material/dialog';
import { UserFilterComponent } from './user-filter.component';
import { UserMultipleActivationFilterComponent } from './request-multiple-activations/user-multiple-activations-filter.component';
import { SendMailPopupComponent } from '../shared/components/sendmail-popup/sendmail-popup.component';


@Component({
    selector: 'pd-user-collection',
    templateUrl: './user-collection.component.html',
    styleUrls: ['./user-collection.component.css']
})
export class UserCollectionComponent extends PagedCollectionComponent<User> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<User>([
        { colDef: 'mfaEnabled', prop: x => x.mfaEnabled, searchable: SearchableType.Boolean},
        { colDef: 'isMfaExempt', prop: x => x.isMfaExempt, searchable: SearchableType.Boolean},
        { colDef: 'firstName', prop: x => x.firstName, searchable: SearchableType.String },
        { colDef: 'lastName', prop: x => x.lastName, searchable: SearchableType.String },
        { colDef: 'email', prop: x => x.email, searchable: SearchableType.String },        
        { colDef: 'personeel', prop: x => x.personeel.naam, searchable: SearchableType.String },
        { colDef: 'meetInstrumenten', prop: x => x.meetInstrumenten, searchable: SearchableType.Boolean },
        { colDef: 'energie', prop: x => x.energie, searchable: SearchableType.Boolean },
        { colDef: 'internalLogin', prop: x => x.internalLogin, searchable: SearchableType.Boolean},        
        { colDef: 'hasRelaties', prop: x => x.hasRelaties, searchable: SearchableType.Boolean },
        { colDef: 'relaties', prop: x => x.relaties, searchable: SearchableType.String },
        { colDef: 'lastLogin', prop: x => x.lastLogin, searchable: SearchableType.Date},
        { colDef: 'lastPasswordChanged', prop: x => x.lastPasswordChanged, searchable: SearchableType.Date}, 
        { colDef: 'locked', prop: x => x.locked, searchable: SearchableType.Boolean}        
    ]);
    isNewItem: any;
    item: any;

    constructor(public service: UserService, protected filter: Filter<User>, injector: Injector, 
        private dialogService: DialogsService, private matDialog: MatDialog
    ) {
        super('/users', injector, User);
    }

    ngOnInit() {

        // Init op 1500 -> ivm de mailing multiselect
		this.defaultPageSize = 1500;

        super.ngOnInit();

        this.filter.onGetChipLabel(x => x.firstName, () => 'Voornaam');
        this.filter.onGetChipLabel(x => x.lastName, () => 'Achternaam');
        this.filter.onGetChipLabel(x => x.email, () => 'Email');
        this.filter.onGetChipLabel(x => x.personeel.naam, () => 'Personeel');
        this.filter.onGetChipLabel(x => x.meetInstrumenten, () => 'MI');
        this.filter.onGetChipLabel(x => x.energie, () => 'EN');
        this.filter.onGetChipLabel(x => x.hasRelaties, () => 'Klantportaal');
        this.filter.onGetChipLabel(x => x.relaties, () => 'Relaties');
        this.filter.onGetChipLabel(x => x.lastLogin, () => 'Laatste login');
        this.filter.onGetChipLabel(x => x.mfaEnabled, () => '2FA geactiveerd');
        this.filter.onGetChipLabel(x => x.isMfaExempt, () => '2FA vrijgesteld');
        this.filter.onGetChipLabel(x => x.internalLogin, () => 'Intern');

        this.orderBy=[2]; 

        if ((this.multiSelectData != null && this.multiSelectData != undefined )) {
            this.hideColumns = ['relaties', 'mfaEnabled', 'isMfaExempt', 'lastPasswordChanged' ];
        }

    }

    displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns 
		if(colDef.colDef == 'isMfaExempt' ) { return false; }

        return super.displayColumn(colDef, ix);
	}

    canDelete(){
        return false;
    }

}
